import { useGlobalProductPageContext } from '../../../contexts/globalProductPageContext';

export function ProductMediaCalloutGrid() {
  const { productAdditionalDetails } = useGlobalProductPageContext();
  const sectionData =
    productAdditionalDetails?.props.children.props.children.props.cms;

  const calloutItems = sectionData?.productCallouts || [];

  if (!calloutItems.length) return null;

  return (
    <div className="my-4 flex flex-col space-y-4 md:my-0 lg:flex-row lg:space-y-0">
      {calloutItems.map((item, index) => (
        <div
          key={index}
          className="flex flex-row items-center space-x-4 px-2 text-center lg:flex-col lg:space-x-0 lg:space-y-4"
        >
          {item.icon && (
            <img
              className="h-9 w-9"
              alt={item.icon.altText}
              src={item.icon.url}
              width={item.icon.width}
              height={item.icon.height}
            />
          )}
          <div className="text-left lg:text-center">
            <h3 className="inline text-xs font-normal lg:block xl:text-lg">
              {item.title}
            </h3>
            <p className="ml-1 inline text-xs lg:ml-0 lg:block xl:text-base">
              {item.content}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
}
